module.exports = __webpack_public_path__ + "img/expand.b3f5dca8.svg";